import CompleteRegistrationModal from '@countryModals/CompleteRegistrationModal.vue';
import Modals from '@store/modules/ui/shared/modal/modals';
import availableModals from '@app/modals/availableModals';

export default {
    ...availableModals,
    [Modals.completeRegistration.code]: CompleteRegistrationModal,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/app/modals/availableModals.ts